cb.define(['common/common_VM.Extend.js'], function (common) {
    var AA_sys_option_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            viewmodel.on("afterLoad", function (data) {
                    let registInfo = cb.rest.AppContext.user.registInfo;
                    if (registInfo.URetail == undefined || registInfo.URetail == null || !registInfo.URetail) {
                        if (viewmodel.get("isCreateProduct")) {
                            viewmodel.get("isCreateProduct").setVisible(false)
                        }
                    }
                }
            );

        }
    }
    try {
        module.exports = AA_sys_option_VM_Extend;
    } catch (error) {
    }
    return AA_sys_option_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_sys_option_VM.Extend.js